var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.tasks').controller('TaskTypesCtrl', ["taskTypes", "TaskTypes", "$scope", "$modalInstance", "$timeout", "TaskTypeService", "EmploymentService", "$filter", function(taskTypes, TaskTypes, $scope, $modalInstance, $timeout, TaskTypeService, EmploymentService, $filter) {
  var cancelEdit, initNew, reload;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.types = taskTypes;
  $scope.colors = colorPickerColors;
  initNew = function() {
    $scope.newTaskType = {};
    return $scope.createErrors = void 0;
  };
  initNew();
  $scope.create = function() {
    $scope.isLoading = true;
    return TaskTypes.post($scope.newTaskType).then(function() {
      initNew();
      reload();
      return $scope.isLoading = false;
    }, function(response) {
      $scope.createErrors = response.data.errors;
      return $scope.isLoading = false;
    });
  };
  $scope.save = function() {
    return TaskTypeService.save($scope.editType, $scope.editType.name).then(function() {
      $scope.error = void 0;
      $scope.editError = void 0;
      return reload();
    }, function(response) {
      return $scope.editError = response.data.errors.color ? `${$filter('spell')('Color')} is invalid` : "Error saving task type.";
    });
  };
  $scope.delete = function(type) {
    if (type.id) {
      return TaskTypeService.delete(type).then(function() {
        $scope.error = void 0;
        return reload();
      }, function() {
        return $scope.error = 'This task type is in use and cannot be deleted at this time.';
      });
    } else if (!type.id) {
      return $scope.types.pop();
    }
  };
  $scope.close = function() {
    return $modalInstance.close();
  };
  $scope.edit = function(type) {
    $scope.editError = void 0;
    $scope.editType = type;
    if ($scope.isCustomColorSelected(type)) {
      return $scope.editType.customColor = $scope.editType.color;
    }
  };
  $scope.isCustomColorSelected = function() {
    var ref;
    return $scope.editType.color && (ref = $scope.editType.color, indexOf.call($scope.colors, ref) < 0);
  };
  $scope.setColor = function(color) {
    $scope.editType.color = $scope.editType.color === color ? null : color;
    return $scope.editType.customColor = void 0;
  };
  $scope.$on('colorpicker-closed', function(currentScope, color) {
    return $timeout(function() {
      return $scope.editType.color = color.value || null;
    });
  });
  cancelEdit = function() {
    $scope.editError = void 0;
    return $scope.editType = void 0;
  };
  reload = function() {
    cancelEdit();
    return TaskTypeService.reload().then(function(types) {
      return $scope.types = types;
    });
  };
  return reload();
}]);
